import * as Effects from 'redux-saga/effects'
import { getUserDateOffset } from '../../reducers/userAccount/selectors/getUserDate'

export default function*() {
  while (true) {
    const userOffset = yield Effects.select(getUserDateOffset)

    if (userOffset !== new Date().getTimezoneOffset()) {
      window.location.reload()
    }
    yield Effects.delay(500)
  }
}
